export default __webpack_public_path__ + "static/hoodieprofile3-b86b4328246f9f33c4313c7256e7f9c4.png";